import {ORDERS_URL_PARAMS} from '../constants';

import {browserHistory} from '@/shared/utils';

export const clearUrlParamsFromGrid = ({
  urlPrefix = null,
  additionalParams = [],
} = {}) => {
  const params = [
    ...additionalParams,
    ORDERS_URL_PARAMS.LIMIT,
    ORDERS_URL_PARAMS.OFFSET,
    ORDERS_URL_PARAMS.ORDERING,
  ].reduce((acc, param) => {
    const key = urlPrefix ? `${urlPrefix}_${param}` : param;
    acc[key] = key;
    return acc;
  }, {});

  browserHistory.deleteParameters(params);
};

interface UrlParamsValues {
  limit: number;
  offset: number;
  ordering: string;
}

export const getUrlParamsValues = (
  urlPrefix = '',
  defaultLimit = 20
): UrlParamsValues => ({
  limit: +browserHistory.getParameterValue(
    `${urlPrefix}${ORDERS_URL_PARAMS.LIMIT}`,
    String(defaultLimit)
  ),
  offset: +browserHistory.getParameterValue(
    `${urlPrefix}${ORDERS_URL_PARAMS.OFFSET}`,
    '0'
  ),
  ordering: browserHistory.getParameterValue(
    `${urlPrefix}${ORDERS_URL_PARAMS.ORDERING}`,
    `-${ORDERS_URL_PARAMS.ORDER_DATE}`
  ),
});
